const education = [
    {
        id: 1,
        degree: "Master Of Science in Computer Science",
        institution: "College of Engineering, Guindy",
        location: "Chennai, India",
        startDate: "July 2021",
        endDate: "Present",
        details: [
            "Specialized in Data Structures & Algorithms, Object Oriented Programming, Software Engineering, Database Management Systems. Worked on various projects including a RAG chatbot, Attendance Management Systems, and programming in languages such as Python, Java, and C++.",
            "CGPA: 7.32/10"
        ]
    },
];

export default education;